
var taxes = angular.module('applicationTaxes', ['classy', 'standardCudFactory', 'applyDocuments', 
    'familyTaxModel', 'familyModel', 'familyTaxFamilyModel', 'taxEmailModel', 'angularFileUpload']);
